import { data } from '../../svg/Table/data';
import { makeIcon } from '../makeIcon';

export const Table = makeIcon(data, 'table', 'Table');

export default Table;
